import React from 'react';
import ReactPlayer from 'react-player';
import cx from 'classnames';
import './VideoPlayer.scss';

const VideoPlayer = (props) => {
  const { className, ...res } = props;

  return (
    <div className={cx('video-player', className)}>
      <ReactPlayer className="react-player" {...res} />
    </div>
  );
};

export default VideoPlayer;
